import Container from '../ui/Container';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';
import Button from '../ui/Button';
import Icon from '../ui/Icon';
import { industries } from '../../data/industries';

/** Sector cards. `limit` trims the list for the Home preview. */
export default function IndustriesGrid({ limit, showCta = true }) {
  const items = limit ? industries.slice(0, limit) : industries;

  return (
    <section className="section bg-white" id="industries">
      <Container>
        <SectionHeading
          eyebrow="Industries we serve"
          title="Sector-specific handling, not a one-size process"
          description="A hospital analyser and a bank's ATM fleet carry very different risks. Our protocols, packaging and paperwork change with the sector."
        />

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((industry, index) => (
            <Reveal key={industry.id} delay={index * 0.05}>
              <article
                id={industry.id}
                className="group h-full rounded-xl2 border border-ink-100 bg-surface p-6 transition-all duration-300 ease-smooth hover:-translate-y-1.5 hover:border-brand-200 hover:bg-white hover:shadow-lift"
              >
                <div className="flex items-start gap-4">
                  <span className="grid h-11 w-11 flex-none place-items-center rounded-xl bg-white text-brand-700 shadow-soft transition-all duration-300 group-hover:bg-brand-600 group-hover:text-white">
                    <Icon name={industry.icon} className="h-5 w-5" />
                  </span>
                  <h3 className="mt-1 font-display text-base font-semibold text-ink-900">
                    {industry.name}
                  </h3>
                </div>

                <p className="mt-4 text-sm leading-relaxed text-ink-500">{industry.description}</p>

                <ul className="mt-5 flex flex-wrap gap-1.5">
                  {industry.streams.map((stream) => (
                    <li
                      key={stream}
                      className="rounded-full border border-ink-200 bg-white px-2.5 py-1 text-[0.7rem] font-medium text-ink-600"
                    >
                      {stream}
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>

        {showCta && limit && (
          <Reveal className="mt-12 flex justify-center">
            <Button to="/industries" variant="outline" size="lg">
              See all industries we serve
            </Button>
          </Reveal>
        )}
      </Container>
    </section>
  );
}
